import { useContext } from 'react';
import useGetItemsByCollectionAddress from '../../hooks/useGetItemsByCollectionAddress';
import { useGetRarityRangeListings } from '../../hooks/useGetRarityRangeListings';
import { collectionItemsTabsContext } from './Collection_items';
import { setFilterToLocalstorage } from '../categories/filterCategoryItem';
import { formatEther, parseEther } from 'ethers/lib/utils.js';
import { Tooltip } from '@mui/material';
import { RiErrorWarningLine } from 'react-icons/ri';
import NFTItemCard from '../categories/nftItemCard';

const getFilter = (rarityFrom, rarityTo) => {
  return {
    search: '',
    buy_now: true,
    itemAttributes: {},
    collectionIds: [],
    sort: {
      id: 'updatedAt:desc',
      text: 'Recent Activity',
    },
    categories: { id: 1, text: 'All Categories' },
    chainIds: [],
    tags: [],
    rarity: {
      min: rarityFrom,
      max: rarityTo,
    },
  };
};

const ItemsInTable = ({ collectionAddress, rarityFrom, rarityTo }) => {
  const { data: swr, isLoading } = useGetItemsByCollectionAddress(
    collectionAddress,
    getFilter(rarityFrom, rarityTo),
    3,
    1,
    false,
    null,
  );

  return (
    <div className='flex w-full space-x-1 overflow-auto'>
      {/* <div className='w-36'> */}
      {swr?.results.map((item) => {
        return (
          <div className='w-full max-w-[175px]' key={item.id}>
            <NFTItemCard item={item} itemOwner={item.ownerObject} />
          </div>
        );
      })}
      {/* </div> */}
    </div>
  );
};

export const CollectionRarityRangeStats = ({ collectionAddress, setFilter }) => {
  const { data: ownerStats } = useGetRarityRangeListings(collectionAddress);
  const { data: range } = ownerStats || {};
  const { itemsTabs, setItemsTabs } = useContext(collectionItemsTabsContext);

  if (!range || range.length === 0) return null;

  range?.sort((a, b) => Number(a.between.split('-')[0]) - Number(b.between.split('-')[0]));
  return (
    <>
      <div
        className={`mt-3 w-full rounded-lg border border-jacarta-200 px-4 pb-4 dark:border-jacarta-600`}
      >
        <h1 className='ml-0 mb-2 mt-4 font-bold'>
          <span>Listings By Rarity Range</span>
        </h1>
        <div className='p-y h-[calc(100%-73px)] w-full'>
          <table className='w-full'>
            <thead className=' text-white'>
              <tr className=''>
                <th className='w-fit rounded-l-md bg-jacarta-600 pl-4 text-left'>Rarity Rank</th>
                <th className='bg-jacarta-600 pl-4 text-left'>Floor</th>
                <th className='rounded-r-md bg-jacarta-600 pl-4 text-left'>Items</th>
              </tr>
            </thead>
            <tbody>
              {range &&
                range.map((r, i) => {
                  const [from, to] = r.between.split('-');
                  return (
                    <>
                      <tr key={r.between} className=''>
                        <td className='w-fit py-6 pl-4'>{r.between}</td>
                        <td className='w-fit py-6 pl-4'>{r.floor && formatEther(r.floor)}</td>
                        <td className=' h-full max-w-[50vw] items-center pb-5 pl-4 pt-5'>
                          {r.count > 0 ? (
                            <>
                              {
                                <ItemsInTable
                                  collectionAddress={collectionAddress}
                                  rarityFrom={from}
                                  rarityTo={to}
                                />
                              }
                              {r.count > 0 && (
                                <span
                                  onClick={() => {
                                    setFilterToLocalstorage(collectionAddress, getFilter(from, to));
                                    setItemsTabs(1);
                                    //setFilter(getFilter(from, to));
                                  }}
                                  className=' ml-4 flex cursor-pointer underline'
                                >
                                  Check {r.count} items in this range
                                  <Tooltip
                                    title={
                                      'The status of NFTs is updated instantly. There may not be as many NFTs as the number in the expression. '
                                    }
                                    className='relative hidden sm:block'
                                  >
                                    <span className='absolute top-2 -right-1 font-display text-sm font-semibold text-accent hover:text-accent-light dark:text-white'>
                                      <RiErrorWarningLine size={14} />
                                    </span>
                                  </Tooltip>
                                </span>
                              )}
                            </>
                          ) : (
                            <span className='py-6'>No items</span>
                          )}
                        </td>
                      </tr>
                      {i !== range.length - 1 && <tr className='border-t border-[#575757b8]' />}
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
